if (!customElements.get('gd-breed-search')) {
  customElements.define('gd-breed-search', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const controls = this.querySelector('[data-search-controls]');
      const input = this.querySelector('input');
      const items = [...this.querySelectorAll('[data-breed]')];
      const count = this.querySelector('[data-count]');
      const empty = this.querySelector('[data-empty]');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const update = () => {
        const query = normalize(input.value);
        let visible = 0;
        items.forEach(item => {
          item.hidden = !normalize(item.dataset.breed).includes(query);
          if (!item.hidden) visible++;
        });
        count.textContent = `${visible} ${visible === 1 ? 'breed' : 'breeds'} on this page`;
        empty.hidden = visible !== 0;
      };
      controls.hidden = false;
      input.addEventListener('input', update);
      input.addEventListener('search', update);
      update();
    }
  });
}
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.gd-mobile-nav details[open]').forEach(details => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.gd-mobile-nav details[open]').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});
